import React, { useState } from 'react';
import { Styles } from './style';
import { useNavigate } from 'react-router-dom';
import Person from '@assets/images/person.png';
import { Agent, agentData } from './agentData';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';
import PageControl from '@components/PageControl';

const UserListScreen: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const normalizeText = (text: string) => {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const filteredUsers = agentData.filter((user: Agent) => {
    const searchLower = normalizeText(searchTerm);
    return (
      normalizeText(user.agentName).includes(searchLower) ||
      normalizeText(user.email).includes(searchLower) ||
      normalizeText(user.phone).includes(searchLower)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleViewUser = (userId: string) => {
    navigate(`/area-do-corretor/usuarios/${userId}`);
  };

  const handleDeleteUser = (userId: string) => {
    console.log('Deletar usuário:', userId);
  };

  return (
    <AuthenticatedLayout>
      <h1>Usuários</h1>
      <Styles.RectangleBar />
      <Styles.SectionFilters>
        <Styles.FlexContainer>
          <Styles.ShowText>Mostrar</Styles.ShowText>
          <Styles.SelectContainer>
            <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
              <option value={3}>3</option>
              <option value={6}>6</option>
              <option value={9}>9</option>
              <option value={12}>12</option>
            </select>
          </Styles.SelectContainer>
          <Styles.RecordsText>Registros</Styles.RecordsText>
        </Styles.FlexContainer>
        <Styles.Button
          onClick={() => navigate('/area-do-corretor/usuarios/novo')}>
          CADASTRAR NOVO
        </Styles.Button>
        <Styles.SearchContainer>
          <Styles.SearchInput
            type="text"
            placeholder="Buscar por nome, e-mail ou telefone..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Styles.SearchContainer>
      </Styles.SectionFilters>

      {/* Lista de Usuários */}
      {currentUsers.map((user: Agent) => (
        <Styles.UserCard key={user.id}>
          <Styles.UserIcon>
            <img
              src={user.agentPhoto || Person}
              alt=""
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                objectFit: 'cover'
              }}
            />
          </Styles.UserIcon>
          <Styles.UserInfo>
            <Styles.UserName>
              <h1>{user.agentName}</h1>
              <Styles.UserTypeBadge type={user.userType}>
                {user.userType}
              </Styles.UserTypeBadge>
            </Styles.UserName>
          </Styles.UserInfo>
          <Styles.Buttons>
            <Styles.ViewButton onClick={() => handleViewUser(user.id)}>
              VISUALIZAR
            </Styles.ViewButton>
            <Styles.DeleteButton onClick={() => handleDeleteUser(user.id)}>
              EXCLUIR
            </Styles.DeleteButton>
          </Styles.Buttons>
        </Styles.UserCard>
      ))}

      {/* Paginação */}
      <PageControl
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={handlePageChange}
      />
    </AuthenticatedLayout>
  );
};

export default UserListScreen;
